import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material';
import {DialogConfigBase} from '../dialog-config-base';
import {DialogConfigInterface} from '../dialog-config.interface';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {AssetsService} from '../../../services/assets.service';

@Component({
  selector: 'app-aztec-scanner-qr-dialog',
  templateUrl: './aztec-scanner-qr-dialog.component.html',
  styleUrls: []
})
export class AztecScannerQrDialogComponent implements OnInit {

  loading: boolean = true;
  phoneImageSrc: string = './assets/images/aztec-phone.png';
  arrowImageSrc: string;

  private readonly TRANSLATIONS_CONTAINER_KEY = 'AZTEC_SCANNER_QR_DIALOG';
  private qrCodeData: string;

  static getConfigBuilder(): AztecScannerQrDialogConfig {
    return new AztecScannerQrDialogConfig();
  }

  get qrCodeImageSrc(): string {
    return this.qrCodeData ? `data:image/png;base64,${this.qrCodeData}` : null;
  }

  constructor(private dialog: MatDialogRef<AztecScannerQrDialogComponent>,
              private assetsService: AssetsService,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.initArrowImageSrc();
    this.initQRCode();
  }

  getTranslationKey(key: string): string {
    return `${this.TRANSLATIONS_CONTAINER_KEY}.${key}`;
  }

  close() {
    this.dialog.close();
  }

  private async initQRCode() {
    this.qrCodeData = this.data.data.qrCodeData;
    this.loading = !isNotNullOrUndefined(this.qrCodeData);
  }

  private initArrowImageSrc(): void {
    this.arrowImageSrc = `${this.assetsService.getIconsDirectoryPath()}/aztec-scanner-arrow.svg`;
  }

}

export class AztecScannerQrDialogConfig extends DialogConfigBase implements DialogConfigInterface {
  private config: MatDialogConfig = {
    panelClass: 'aztec-scanner-qr-dialog-panel'
  };

  constructor() {
    super();
  }

  buildConfiguration(data: any): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}
